import { render, staticRenderFns } from "./Apitest.vue?vue&type=template&id=3cb1ceef&scoped=true"
import script from "./Apitest.vue?vue&type=script&lang=js"
export * from "./Apitest.vue?vue&type=script&lang=js"
import style0 from "./Apitest.vue?vue&type=style&index=0&id=3cb1ceef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1ceef",
  null
  
)

export default component.exports